import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { PrimaryCTAButton, PrimaryOutlinedCTAButton } from "../Buttons";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";

const AlertDialog = ({
  heading = "Quit Case",
  desc = "Are you sure you want to Quit this case? All the negotiation progress will be lost if you quit case at this point",
  primaryBtnText = "Submit",
  secondaryBtnText = "Close",
  clickSecondarybtn = () => { },
  clickPrimaryBtn = () => { },
  isOpen = false,
  onDialogClose = () => { },
  moveTranscriptBtnText,
  movePrimaryBtn = () => { },
  moveTranscript
}) => {
  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={onDialogClose}
        disableRestoreFocus={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Heading style={{ margin: "30px auto 36px" }}>{heading}</Heading>
        <Description
          style={{ margin: "0 62px 80px", width: "400px", textAlign: "center" }}
        >
          {desc}
        </Description>
        <ButtonWrapper
          style={{
            margin: "auto",
            width: "418px",
            display: "flex",
            justifyContent: "center",
            marginBottom: "52px",
          }}
        >
          {secondaryBtnText && (
            <PrimaryOutlinedCTAButton
              style={{ height: "48px", width: "192px", marginRight: 20 }}
              onClick={clickSecondarybtn}
            >
              {secondaryBtnText}
            </PrimaryOutlinedCTAButton>
          )}
          {primaryBtnText && (
            <PrimaryCTAButton
              style={{ height: "48px", width: "192px" }}
              onClick={clickPrimaryBtn}
            >
              {primaryBtnText}
            </PrimaryCTAButton>
          )}
          {moveTranscript && (
            <PrimaryCTAButton
              style={{ height: "48px", width: "192px", marginLeft: 20 }}
              onClick={movePrimaryBtn}
            >
              {moveTranscriptBtnText}
            </PrimaryCTAButton>
          )}
        </ButtonWrapper>
      </Dialog>
    </div>
  );
};
export default AlertDialog;

const ButtonWrapper = styled.div`
  display: flex;
`;
const Heading = styled.div`
  font-family: ${theme.fonts.primaryFontBold};
  font-size: 18px;
  font-weight: 800;
  color: ${COLORS.COLOR_DARK};
  margin: auto;
  margin-top: 23px;
  margin-bottom: 22px;
`;
const Description = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
`;
